export interface ApiSetClaimCompareTranslationCacheRequest {
    patent_id: string;
    trans_lang: string;
    translation: string;
    text: string;
}

export interface ApiSetClaimCompareTranslationCacheResponse {
    data: Record<string, string>;
}

export const SetClaimCompareTranslationCache = Symbol.for('SetClaimCompareTranslationCache');

export interface SetClaimCompareTranslationCache {
    setClaimCompareTranslationCache(request: ApiSetClaimCompareTranslationCacheRequest): Promise<ApiSetClaimCompareTranslationCacheResponse>;
}